import React, { FC } from 'react';

const SectionTitle: FC<{ eyebrow: string; title: string; subtitle?: string }> = ({ eyebrow, title, subtitle }) => (
  <div className="section-title reveal">
    <span className="eyebrow">{eyebrow}</span>
    <h2>{title}</h2>
    {subtitle && <p>{subtitle}</p>}
  </div>
);

export default SectionTitle;
